import React from "react";
import { Type } from "@ebscois/react-component-library";

const PageContextError = () => {
  return (
    <div>
      <Type
        element="p"
        fontSize="sm"
        fontFamily="secondary"
        display="block"
        fontWeight="semibold"
      >
        We're sorry! The Page you're trying to Load is missing context.
      </Type>
      <Type
        element="p"
        fontSize="sm"
        fontFamily="secondary"
        fontWeight="semibold"
      >
        Please Login again.
      </Type>
    </div>
  );
};

PageContextError.displayName = "PageContextError";

export default PageContextError;
